import { useEffect, useState } from 'react';


interface Props {
    mode: 'view' | 'edit' | 'review';
    isDirty: boolean;
    isSaving: boolean;
    isFinalSaving: boolean;
    onDraftSaveClick: (e: React.MouseEvent) => void;
    onApproveClick: (e: React.MouseEvent) => void;
    onRejectClick: (e: React.MouseEvent) => void;
    onCloseClick: (e: React.MouseEvent) => void;
}

export function SubmitButtonBar({
    mode,
    isDirty,
    isSaving,
    isFinalSaving,
    onDraftSaveClick,
    onApproveClick,
    onRejectClick,
    onCloseClick,
}: Props) {

    const [hasStartedSaving, setHasStartedSaving] = useState(false);

    useEffect(() => {
        setHasStartedSaving(hasStartedSaving || isSaving);
    }, [isSaving, hasStartedSaving]);


    const message = isSaving
        ? 'Saving...'
        : hasStartedSaving && !isDirty
            ? 'Changes saved'
            : '';

    return (
        <div className='button-bar' style={{ marginTop: '20px' }}>
            {mode === 'edit' && <>
                <button
                    type='submit'
                    disabled={isFinalSaving}
                    children='Submit for review'
                />
                <button
                    disabled={isFinalSaving}
                    onClick={onDraftSaveClick}
                    children='Save draft'
                />
            </>}

            {mode === 'review' && <>
                <button
                    disabled={isFinalSaving}
                    onClick={onApproveClick}
                    children='Approve'
                />
                <button
                    disabled={isFinalSaving}
                    onClick={onRejectClick}
                    children='Reject'
                />
            </>}

            <button onClick={onCloseClick}>Close</button>
            <span>{message}</span>
        </div>
    );
}
